import PROFILE_ADD from "@graphql/mutations/profile_add";
import Session from "@lib/session";
import {
  ProfileAddDocument,
  ProfileAddMutationResult,
  ProfileAddMutationVariables,
} from "@graphql/api";

interface ProfileAddProps {
  email: string | undefined;
  linkedReservations?: Array<string>;
  name?: string;
  options?: {
    noAutoLogin?: boolean;
  };
  password: string;
  telephone?: string;
}

interface ProfileAddReturn {
  error?: string;
  profileId?: number;
}

export default async function profileAdd({
  email,
  linkedReservations,
  name,
  options = {},
  password,
  telephone,
}: ProfileAddProps): Promise<ProfileAddReturn> {
  const client = global.window.apolloClient;
  const mutVars: ProfileAddMutationVariables = {
    email,
    linkedReservations,
    name,
    password,
    telephone,
  };
  const result: ProfileAddMutationResult = await client.mutate({
    mutation: ProfileAddDocument,
    variables: mutVars,
  });

  const success = result?.data?.profileAdd.success,
    profileId = result?.data?.profileAdd.profileId,
    errorMessage = result?.data?.profileAdd.errorMessage;

  if (success && profileId && !options?.noAutoLogin) {
    // Add new profile to session.
    const profiles = Session.getBooking().profiles;
    profiles.user = profileId;
    Session.updateBooking({ profiles });
    await client.resetStore();
  }

  return { error: errorMessage, profileId };
}
